import React from 'react';

/**
 * Subtle background texture for CityPicker/ProfileView's blank space — a solid
 * accent circle plus a dot-grid halftone circle, both low-opacity. `position:
 * fixed` relies on the parent panel having its own `transform` (both callers
 * do, for their slide animation), which makes it the containing block for
 * fixed descendants — so these stay put on scroll without a separate
 * non-scrolling wrapper layer.
 */
const DecorativeCircles: React.FC = () => (
  <>
    <div
      aria-hidden="true"
      style={{
        position: 'fixed',
        top: '-70px',
        right: '-70px',
        width: 260,
        height: 260,
        borderRadius: '50%',
        backgroundColor: 'var(--color-clay)',
        opacity: 0.07,
        pointerEvents: 'none',
      }}
    />
    <div
      aria-hidden="true"
      style={{
        position: 'fixed',
        bottom: '-50px',
        left: '-50px',
        width: 220,
        height: 220,
        borderRadius: '50%',
        backgroundImage: 'radial-gradient(circle, var(--color-primary) 1.5px, transparent 1.5px)',
        backgroundSize: '11px 11px',
        opacity: 0.16,
        pointerEvents: 'none',
      }}
    />
  </>
);

export default DecorativeCircles;
